export enum Environments {
    Local = 1,
    Stage = 2,
    Live = 3,
    Stage2 = 4,
    Dev = 5,
    Test = 6
}